import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { FileActions } from '../FileActions';
import { SuccessGreenVi } from 'Images';
import { getCleanFileName } from 'Utils';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
interface IFileRow {
  fileName: string;
  deleteFile: () => void;
  watchFile: () => void;
}
export const FileRow = (props: IFileRow) => {
  const filename = getCleanFileName(props.fileName);
  const isDesktop = useIsDesktop();

  return (
    <Grid container>
      <Grid
        container
        alignItems='center'
        sx={{
          padding: isDesktop ? '16px 0 0 0' : '5px 0 0 0',
        }}
        component={'fieldset'}
      >
        <legend>{`${
          Dictionary[DICTIONARY.UniversalRequest].uploadFile.file
        } ${filename}`}</legend>
        <Stack
          sx={{
            mt: 1,
          }}
        >
          <Box
            aria-describedby={`${
              Dictionary[DICTIONARY.UniversalRequest].uploadFile.file
            } ${filename}`}
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              maxWidth: isDesktop ? undefined : '100%',
              border: '1px solid #B7CCFF',
              borderRadius: '8px',
              padding: isDesktop ? '12px 14px' : '8px 12px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              backgroundColor: isDesktop ? undefined : '#fff',
            }}
          >
            <Avatar
              alt=''
              src={SuccessGreenVi}
              sx={{ width: '24px', height: '24px' }}
            />
            <Typography
              noWrap
              title={filename}
              sx={{
                fontWeight: 'bold',
                fontSize: isDesktop ? '20px' : '18px',
                color: '#344266',
              }}
            >
              {filename}
            </Typography>
          </Box>

          <FileActions
            filename={filename}
            deleteFile={props.deleteFile}
            watchFile={props.watchFile}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
